import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bookFlight } from "../../store/flight/actionCreator";

const initialState = {
  from: "",
  to: "",
  date: "",
  guests: "",
  ticketClass: "",
};

export default function InputForm() {
  const dispatch = useDispatch();
  const flights = useSelector((state) => state.flightBooking.flights);
  const [formValues, setFormValues] = useState(initialState);
  const isDisabled = flights.length === 3;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({ ...prevValues, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { from, to, date, guests, ticketClass } = formValues;

    // if there are more than 3 flights, don't allow more
    if (isDisabled) {
      alert("You can only book 3 flights!");
      return;
    }

    // Validate that all fields have been filled in
    if (!from || !to || !date || !guests || !ticketClass) {
      alert("Please fill in all the fields!");
      return;
    }

    // create a unique id for the flight
    const id = `${Date.now()}-${Math.random()}`;

    dispatch(
      bookFlight({
        id,
        from,
        to,
        date,
        guests,
        ticketClass,
      })
    );

    // Clear the form values
    setFormValues(initialState);
    e.target.reset();
  };

  return (
    <div className="mt-[160px] mx-4 md:mt-[160px] relative">
      <div className="bg-white rounded-md max-w-6xl w-full mx-auto">
        <form className="first-hero lws-inputform" onSubmit={handleSubmit}>
          {/* From */}
          <div className="des-from">
            <p>Destination From</p>
            <div className="flex flex-row">
              <img src="./img/icons/Frame.svg" alt="" />
              <select
                className="outline-none px-2 py-2 w-full"
                name="from"
                id="lws-from"
                value={formValues.destinationFrom}
                onChange={handleChange}
                required
              >
                <option value hidden>
                  Please Select
                </option>
                <option>Dhaka</option>
                <option>Sylhet</option>
                <option>Saidpur</option>
                <option>Cox's Bazar</option>
              </select>
            </div>
          </div>
          {/* To */}
          <div className="des-from">
            <p>Destination To</p>
            <div className="flex flex-row">
              <img src="./img/icons/Frame.svg" alt="" />
              <select
                className="outline-none px-2 py-2 w-full"
                name="to"
                id="lws-to"
                value={formValues.destinationTo}
                onChange={handleChange}
                required
              >
                <option value hidden>
                  Please Select
                </option>
                <option>Dhaka</option>
                <option>Sylhet</option>
                <option>Saidpur</option>
                <option>Cox's Bazar</option>
              </select>
            </div>
          </div>
          {/* Date */}
          <div className="des-from">
            <p>Journey Date</p>
            <input
              type="date"
              className="outline-none px-2 py-2 w-full date"
              name="date"
              id="lws-date"
              value={formValues.journeyDate}
              onChange={handleChange}
              required
            />
          </div>
          {/* Guests */}
          <div className="des-from">
            <p>Guests</p>
            <div className="flex flex-row">
              <img src="./img/icons/Vector (1).svg" alt="" />
              <select
                className="outline-none px-2 py-2 w-full"
                name="guests"
                id="lws-guests"
                value={formValues.guests}
                onChange={handleChange}
                required
              >
                <option value hidden>
                  Please Select
                </option>
                <option value={1}>1 Person</option>
                <option value={2}>2 Persons</option>
                <option value={3}>3 Persons</option>
                <option value={4}>4 Persons</option>
              </select>
            </div>
          </div>
          {/* Class */}
          <div className="des-from !border-r-0">
            <p>Class</p>
            <div className="flex flex-row">
              <img src="./img/icons/Vector (3).svg" alt="" />
              <select
                className="outline-none px-2 py-2 w-full"
                name="ticketClass"
                id="lws-ticketClass"
                value={formValues.flightClass}
                onChange={handleChange}
                required
              >
                <option value hidden>
                  Please Select
                </option>
                <option>Business</option>
                <option>Economy</option>
              </select>
            </div>
          </div>
          <button className="addCity" type="submit" id="lws-addCity">
            <svg
              width="15px"
              height="15px"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 4.5v15m7.5-7.5h-15"
              />
            </svg>
            <span className="text-sm">Book</span>
          </button>
        </form>
      </div>
    </div>
  );
}
